import React, { useEffect } from 'react';
import { trackSummaryGenerationError } from '@Containers/Summary/analytics';

// FR-1.8/FR-1.9: the error and user-stopped states are structurally identical — one component,
// two copy variants selected by `entry.cancelled` (SD-1). No icon/avatar in either state.
// FR-1.13: reactions use the same paired error actions as documents — `reactionSummaryEligible`
// is retired, so there is no suppression to compute here at all.
function SummaryError({ entry }) {
  const { cancelled } = entry;

  useEffect(() => {
    if (!cancelled) {
      trackSummaryGenerationError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const heading = "We couldn't generate the summary";
  const body = cancelled
    ? 'The summary generation was interrupted. Try again, or select specific results to summarise instead.'
    : 'Something interrupted the summary generation. Try again, or select specific results to summarise instead.';

  return (
    <div className="ai-search-summary__error" data-testid="summary-error">
      <div className="ai-search-summary__error-message u-els-margin-bottom">
        <p className="u-els-font-size-body-large u-els-font-family-bold">{heading}</p>
        <p>{body}</p>
      </div>
    </div>
  );
}

export default SummaryError;
